import React from "react";
import TableResult from "./component/tableResult";

export default function CustomerPage(){
    return(
        <div className="fitur-all">
            <TableResult />
        </div>
    )
}